import { render } from "./AnnouncementCard.vue?vue&type=template&id=fe0ecccc&scoped=true"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"

import "./AnnouncementCard.vue?vue&type=style&index=0&id=fe0ecccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0ecccc"]])

export default __exports__